<div>
    <mat-carousel
      timings="250ms ease-in"
      [autoplay]="true"
      interval="5000"
      color="accent"
      maxWidth="auto"
      proportion="35"
      slides="5"
      [loop]="true"
      [hideArrows]="true"
      [hideIndicators]="false"
      [useKeyboard]="true"
      [useMouseWheel]="false"
      orientation="ltr"
      [maintainAspectRatio]="isXxxs?false:true"
      slideHeight="500px"
    >
      <mat-carousel-slide
        #matCarouselSlide
        *ngFor="let slide of slides; let i = index"
        [image]="slide.image"
        overlayColor="#00000000"
        [hideOverlay]="false"
      >
      <!--Pre martellata-->
      <!-- <div
        style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center"
      >
      <h1 style="-webkit-text-stroke: 1px black; text-align: center; line-height: 1.2" [ngStyle]="{'font-size': isXxxs?'33px':isXxs?'36px':'44px'}"><b>{{slide.text}}</b></h1>
      </div> -->
      <div
        style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: flex-end; justify-content: flex-end"
      >
      <div style="-webkit-text-stroke: 1px black; text-align: left; line-height: 1.2; color: white; margin-right: 5px" [ngStyle]="{'font-size': isXxxs?'31px':isXxs?'35px':'47px'}"><b>{{slide.text}}<br><br></b></div>
      <!-- <div style="-webkit-text-stroke: 1px black; text-align: left; line-height: 1.2; color: white; margin-right: 5px" [ngStyle]="{'font-size': isXxxs?'31px':isXxs?'35px':'47px'}"><b>{{slide.text}}<br>{{slide.text2}}<br>{{slide.text3}}<br>{{slide.text4}}<br>{{slide.text5}}<br>{{slide.text6}}</b></div> -->
        <!-- <h1>{{ i }}</h1>
        <p>disabled: {{ matCarouselSlide.disabled }}</p>
        <button
          mat-flat-button
          (click)="matCarouselSlide.disabled = !matCarouselSlide.disabled"
        >
          Click me!
        </button> -->
      </div>
    </mat-carousel-slide>
    </mat-carousel>
  </div>
